'use client'

import { Map } from '@vis.gl/react-google-maps'
import { t } from 'i18next'
import Image from 'next/image'
import type { FC } from 'react'
import React from 'react'
import styles from './AddressTypeMap.module.scss'
import { getImageUrl } from '@/tools/image-service/client'
import { useAddressBookContext } from '@/user/address-book/AddressBookContext'
import { MapTooltip } from '@/user/address-book/ui/components/map-tooltip/MapTooltip'
import { ADDRESS_TYPE_ZOOM_LEVEL } from '@/user/address-book/ui/constants'
import { pinIconPaths } from '@/user/address-book/ui/constants'

export const AddressTypeMap: FC = () => {
  const {
    addressData: { latitude, longitude, addressLine },
  } = useAddressBookContext()

  const pinImageSrc = getImageUrl({ source: pinIconPaths.pinIcon })

  const tooltipImageSrc = getImageUrl({
    source: 'dh:customer-assets-glovo/address_flow/address_book/bike_icon.svg',
  })

  const tooltipIcon = <Image alt="Bike icon" height={18} src={tooltipImageSrc} width={20} />

  const googleLogoSrc = getImageUrl({
    source: 'dh:customer-assets-glovo/address_flow/address_book/powered_by_google.svg',
  })

  return (
    <div className={styles.mapContainer}>
      <div className={styles.mapWindowWrapper}>
        <Map
          defaultCenter={{ lat: latitude, lng: longitude }}
          defaultZoom={ADDRESS_TYPE_ZOOM_LEVEL}
          draggableCursor="default"
          fullscreenControl={false}
          gestureHandling="none"
          id="address-type-map"
          mapTypeControl={false}
          streetViewControl={false}
          zoomControl={false}
        />
        <div className={styles.overlay}>
          <div className={styles.tooltipWrapper}>
            <MapTooltip
              description={t('address-list.we-will-deliver-here')}
              icon={tooltipIcon}
              title={addressLine}
            />
          </div>
          <Image alt="Pin icon" className={styles.pin} height={68} src={pinImageSrc} width={86} />
        </div>
      </div>
      <div className={styles.googleLogo}>
        <Image alt="Google logo" height={18} src={googleLogoSrc} width={121} />
      </div>
    </div>
  )
}
